import React, { useState } from "react";
import Gallery1 from "../assets/images/gallery/01.jpeg";
import Gallery2 from "../assets/images/gallery/02.jpg";
import Gallery3 from "../assets/images/gallery/03.jpeg";
import Gallery4 from "../assets/images/gallery/04.jpeg";
import Gallery5 from "../assets/images/gallery/05.jpeg";
import Gallery6 from "../assets/images/gallery/06.jpeg";
import Gallery7 from "../assets/images/gallery/07.jpeg";
import Gallery8 from "../assets/images/gallery/08.jpeg";
import Gallery9 from "../assets/images/gallery/09.jpeg";
import Gallery10 from "../assets/images/gallery/10.jpeg";
import Gallery11 from "../assets/images/gallery/11.jpeg";
import Gallery12 from "../assets/images/gallery/12.jpeg";
import Gallery13 from "../assets/images/gallery/13.jpeg";
import Gallery14 from "../assets/images/gallery/14.jpeg";
import Gallery15 from "../assets/images/gallery/15.jpeg";
import Banner from "../assets/images/banner/page_banner.jpg";

const images = [
  Gallery1,
  Gallery2,
  Gallery3,
  Gallery4,
  Gallery5,
  Gallery6,
  Gallery7,
  Gallery8,
  Gallery9,
  Gallery10,
  Gallery11,
  Gallery12,
  Gallery13,
  Gallery14,
  Gallery15
];

const Gallery: React.FC = () => {
  const [index, setIndex] = useState<number | null>(null);

  // next image
  const nextImage = () => {
    if (index === null) return;
    setIndex((index + 1) % images.length);
  };

  // prev image
  const prevImage = () => {
    if (index === null) return;
    setIndex((index - 1 + images.length) % images.length);
  };

  return (
    <div className="bg-white min-h-screen">

      {/* HERO */}
      <section className="relative h-[420px] flex items-center justify-center text-white">

        {/* background */}
        <div className="absolute inset-0">
          <img
            src={Banner}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary/80"></div>
        </div>

        <div className="relative text-center mt-20">
          <h1 className="text-5xl font-black">Photo Gallery</h1>
          <p className="mt-3 text-lg opacity-90">
            BBMH Hospital Bhilwara
          </p>
        </div>
      </section>

      {/* GRID */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">

          {images.map((img, i) => (
            <div
              key={i}
              onClick={() => setIndex(i)}
              className="cursor-pointer overflow-hidden rounded-2xl shadow-lg group"
            >
              <img
                src={img}
                className="w-full h-96 object-cover group-hover:scale-110 transition duration-500"
              />
            </div>
          ))}

        </div>
      </section>

      {/* LIGHTBOX */}
      {index !== null && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">

          {/* CLOSE */}
          <button
            onClick={() => setIndex(null)}
            className="absolute top-6 right-8 text-white text-4xl"
          >
            ✕
          </button>

          {/* LEFT */}
          <button
            onClick={prevImage}
            className="absolute left-6 text-white text-5xl"
          >
            ❮
          </button>

          {/* IMAGE */}
          <img
            src={images[index]}
            className="max-h-[85vh] max-w-[90vw] rounded-lg shadow-2xl"
          />

          {/* RIGHT */}
          <button
            onClick={nextImage}
            className="absolute right-6 text-white text-5xl"
          >
            ❯
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
